import axios from 'services/index';
import config from 'config/config';

/**
 * Get the contact client care
 */
async function getBrand(brand = null) {
    let url = `${config.API_URL}portal/brand`;
    url = brand != null ? url + `?brand=${encodeURIComponent(brand)}` : '';

    return axios.get(url);
}

export default {
    getBrand
};
